var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "headerSection" } }, [
      _c("div", [
        _c("div", { staticClass: "is-normal has-text-centered" }, [
          _c("h2", [
            _c("i", { staticClass: "fa fa-file" }),
            _vm._v("  Requestation Form")
          ])
        ]),
        _c("hr")
      ]),
      _c(
        "div",
        {
          staticStyle: {
            "max-width": "55%",
            display: "block",
            align: "center",
            margin: "0px auto"
          },
          attrs: { id: "mainContent" }
        },
        [
          _c("form", { attrs: { action: "", id: "" } }, [
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Company Name")])
              ]),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        name: "CompanyName",
                        placeholder: ""
                      }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Address")])
              ]),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: { type: "text", name: "Address1", placeholder: "" }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-one-fifths" }, [
                _c("label", { staticClass: "label" })
              ]),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: { type: "text", name: "Address2", placeholder: "" }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-one-fifths" }, [
                _c("label", { staticClass: "label" })
              ]),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: { type: "text", name: "Address3", placeholder: "" }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" })
              ]),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: { type: "text", name: "Address4", placeholder: "" }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Contact Name")])
              ]),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        name: "ContactName",
                        placeholder: ""
                      }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Phone")])
              ]),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: { type: "text", name: "phone", placeholder: "" }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Email")])
              ]),
              _c("div", { staticClass: "field-body" }, [
                _c("div", { staticClass: "field" }, [
                  _c(
                    "p",
                    { staticClass: "control is-expanded has-icons-left" },
                    [
                      _c("input", {
                        staticClass: "input",
                        attrs: { type: "email", placeholder: "email" }
                      }),
                      _c("span", { staticClass: "icon is-small is-left" }, [
                        _c("i", { staticClass: "fa fa-user" })
                      ])
                    ]
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Type of product")
                ])
              ]),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        name: "TypeOfProduct",
                        placeholder: ""
                      }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Materail")])
              ]),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: { type: "text", name: "Materail", placeholder: "" }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [
                  _vm._v("Type of Painting")
                ])
              ]),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        name: "TypeOfPainting",
                        placeholder: ""
                      }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Torlerance")])
              ]),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: {
                        type: "text",
                        name: "Torlerance",
                        placeholder: ""
                      }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Surface")])
              ]),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c("div", { staticClass: "field" }, [
                  _c("p", { staticClass: "control is-expanded" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: { type: "text", name: "Surface", placeholder: "" }
                    })
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [_vm._v("AttachFile")])
              ]),
              _c("div", { staticClass: "field-body is-normal" }, [
                _c("div", { staticClass: "field has-addons" }, [
                  _c("div", { staticClass: "control" }, [
                    _c("input", {
                      staticClass: "input",
                      attrs: { type: "text", placeholder: "" }
                    })
                  ]),
                  _c("div", { staticClass: "control" }, [
                    _c("a", { staticClass: "button is-info" }, [
                      _vm._v(
                        "\n                            Browse\n                        "
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }, [
                _c("label", { staticClass: "label" }, [_vm._v("Remark")])
              ]),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c("div", { staticClass: "field" }, [
                  _c("textarea", {
                    staticClass: "textarea",
                    attrs: { placeholder: "", row: "5" }
                  })
                ])
              ])
            ]),
            _c("div", { staticClass: "clearfix" }, [_c("br")]),
            _c("div", { staticClass: "field is-horizontal" }, [
              _c("div", { staticClass: "field-label is-normal" }),
              _c("div", { staticClass: "field-body is-two-fifths" }, [
                _c(
                  "div",
                  {
                    staticClass: "control",
                    staticStyle: { "margin-right": "10px" }
                  },
                  [
                    _c("button", { staticClass: "button is-primary" }, [
                      _c("i", { staticClass: "fa fa-check" }),
                      _vm._v("  Submit")
                    ])
                  ]
                ),
                _c("div", { staticClass: "control" }, [
                  _c("button", { staticClass: "button is-danger" }, [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v("  Cancel")
                  ])
                ])
              ])
            ])
          ])
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-14979261", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14979261","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/account/requestation.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-14979261","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/account/requestation.vue
// module chunks = 70